import { isoCountriesEn, isoCountriesFr, isoNationalitiesEn, isoNationalitiesFr } from "./contryUtils";

export function getEnvironment(variableName) {
    return window._env_[variableName];
}

export function getThemeName() {
    return window._env_.THEME;
}

export function getLoginPageTexts() {
    const themeName = getThemeName();

    switch (themeName) {
        case "acl":
            return {
                title: "Ambassador Cruise Line",
                infoDescription : "Welcome to your presales platform portal, your one-stop shop for everything you need before you travel",
                infoItems: [
                    "Complete the online check-in process to access your travel documents.",
                    "Print your luggage labels and boarding passes for your cruise.",
                    `Book your shore ${getExcursionsText()} and onboard ${getExcursionsText()}.`
                ],
                imageAltText: "login banner",
                imageFileName: "login_image.png",
                dateLabel: "Departure date (DD/MM/YYYY)",
                bookingRefLabel: "Booking reference",
                bookingRefPlaceholder: "12345678",
                lastNameLabel: "Lead guest surname",
                lastNamePlaceholder: "Enter Surname",
            }
        case "resco":
            return {
                title: "Resco Cruise Line",
                infoDescription : "Welcome to your presales platform portal, your one-stop shop for everything you need before you travel",
                infoItems: [
                    "Complete the online check-in process to access your travel documents.",
                    "Print your luggage labels and boarding passes for your cruise.",
                    `Book your shore ${getExcursionsText()} and onboard ${getExcursionsText()}.`
                ],
                imageAltText: "login banner",
                imageFileName: "login_image.png",
                dateLabel: "Departure date (DD/MM/YYYY)",
                bookingRefLabel: "Booking reference",
                bookingRefPlaceholder: "12345678",
                lastNameLabel: "Lead guest surname",
                lastNamePlaceholder: "Enter Surname",
            }
        default:
            return {
                title: "Ambassador Cruise Line",
                infoDescription : "Welcome to your presales platform portal, your one-stop shop for everything you need before you travel",
                infoItems: [
                    "Complete the online check-in process to access your travel documents.",
                    "Print your luggage labels and boarding passes for your cruise.",
                    `Book your shore ${getExcursionsText()} and onboard ${getExcursionsText()}.`
                ],
                imageAltText: "login banner",
                imageFileName: "login_image.png",
                dateLabel: "Departure date (DD/MM/YYYY)",
                bookingRefLabel: "Booking reference",
                bookingRefPlaceholder: "12345678",
                lastNameLabel: "Lead passenger surname",
                lastNamePlaceholder: "Enter Surname",
            }
    }
}

export function getCartErrorModalHeaderText() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "A Change to Experience Availability has Occurred";
        case "cfc":
            return "Une modification de la disponibilité des excursions est survenue";
        default:
            return "A Change to Experience Availability has Occurred";
    }
}

export function getCartErrorModalButtonText() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "Cancel all conflicting items from your planner";
        case "cfc":
            return "Annuler tous les éléments en conflit de votre panier";
        default:
            return "Remove the listed items from your planner";
    }
}

export function getPaymentConfirmationThankYouText() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return `Thank you for your ${getExcursionText()} pre-registration with Ambassador Cruise Line`;
        case "cfc":
            return `Merci d'avoir pré-réservé votre ${getExcursionText()} avec CFC Croisières`;
        default:
            return `Thank you for your ${getExcursionText()} pre-registration with Ambassador Cruise Line`;
    }
}

export function getHeaderBackgroundClass() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
        case "cfc":
            return "bg-white";
        case "resco":
            return "bg-grey-lightest";
        default:
            return "bg-primary-light";
    }
}

export function getExcursionText(capitalize = false) {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return capitalize ? "Experience" : "experience";
        case "cfc":
            return capitalize ? "Excursion" : "excursion";
        default:
            return capitalize ? "Excursion" : "excursion";
    }
}

export function getExcursionsText(capitalize = false) {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return capitalize ? "Experiences" : "experiences";
        case "cfc":
            return capitalize ? "Excursions" : "excursions";
        default:
            return capitalize ? "Excursions" : "excursions";
    }
}

export function getProjectName() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "My Ambassador Sailing";
        case "cfc":
            return "Enregistrement en linge";
        default:
            return "Cruise Control";
    }
}

export function getBackToDashboardText(isTradePortal = false) {
    const themeName = getThemeName();
    if (isTradePortal) {
        switch (themeName) {
            case "acl":
                return "Back to My Trade Portal";
            case "cfc":
                return "Retour au portail Trade";
            default:
                return "Back to My Trade Portal";
        }
    }
    switch (themeName) {
        case "acl":
            return `Back to ${getProjectName()} Dashboard`;
        case "cfc":
            return "Retour au tableau de bord";
        default:
            return "Cruise Control";
    }
}


export function getDashboardTitleText() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "Guest Information and Check In";
        case "cfc":
            return "Enregistrement en ligne";
        default:
            return `${getProjectName()} dashboard`;
    }
}

export function getItineraryTitleText() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return getProjectName();
        case "cfc":
            return "Pré-réservation des excursions";
        default:
            return getProjectName();
    }
}

export function showUPTInfoBox() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return true;
        default:
            return false;
    }
}

export function getLogOutModalTitle() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "My Ambassador Sailing";
        case "cfc":
            return "Enregistrement en linge";
        default:
            return "Cruise planner";
    }
}

export function getItineraryDayLabelWidthClass() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "w-16";
        case "cfc":
            return "w-18";
        default:
            return "w-16"
    }
}


export function getExcursionConflictGroupText(group) {
    const themeName = getThemeName();

    switch (themeName) {
        case "cfc":
            switch (group) {
                case "SoldOut":
                    return `Les ${getExcursionsText()} suivantes sont actuellement complètes et doivent être supprimées de votre panier.`;
                case "Bookable":
                    return `Les ${getExcursionsText()} suivantes sont désormais disponibles et peuvent être réservées.`;
                case "Waitlisted":
                    return `Les ${getExcursionsText()} suivantes ne sont actuellement pas disponibles, mais vous pouvez vous inscrire sur la liste d’attente.`;
                default:
                    return `Une erreur s’est produite lors de la réservation des ${getExcursionsText()} suivantes. Veuillez les supprimer de votre panier et réessayer.`;
            }
        case "acl":
        default:
            switch (group) {
                case "SoldOut":
                    return `The following ${getExcursionsText(true)} are currently sold out and need to be removed from your planner.`;
                case "Bookable":
                    return `The following ${getExcursionsText(true)} are now available and can be reserved.`;
                case "Waitlisted":
                    return `The following ${getExcursionsText(true)} are currently not available, but you can join the waitlist.`;
                default:
                    return `There has been an error while reserving the following ${getExcursionsText(true)}. Please remove them from your planner and try again.`;
            }
    }
}

export function getBoardingPassImage(isEventSubType=false){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return isEventSubType ? "boarding_pass_event_header.jpg" : "boarding_pass_header.jpg";
        case "cfc":
            return "cfc_boarding_pass_header.png";
        case "resco":
            return "resco_boarding_pass_header.png";
        default:
            return "boarding_pass_header.jpg";
    }
}

export function getIsoCountries(){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return isoCountriesEn;
        case "cfc":
            return isoCountriesFr;
        default:
            return isoCountriesEn;
    }
}

export function getIsoNationalities(){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return isoNationalitiesEn;
        case "cfc":
            return isoNationalitiesFr;
        default:
            return isoNationalitiesEn;
    }
}

export function getTermsAndConditionsUrl(){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "/DestEx_General_Info_Conditions___69826agy.pdf";
        case "cfc":
            return "/Informations_generales_et_Conditions_des_excursions.pdf";
        default:
            return "/DestEx_General_Info_Conditions___69826agy.pdf";
    }
}

export function getDiningTermsAndConditionsUrl(){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "/Speciality_Dining_and_Onboard_Activities_Terms_and_Conditions_V1.0.pdf";
        case "cfc":
            return "/Informations_generales_et_Conditions_de_la_restauration_et_des_activites_a_bord.pdf";
        default:
            return "/Speciality_Dining_and_Onboard_Activities_Terms_and_Conditions_V1.0.pdf";
    }
}


export function getCCPageInfoText(){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "";
        case "cfc":
            return "Veuillez enregistrer une carte bancaire pour chaque passager";
        default:
            return "";
    }
}

export function getJoinWaitListText(){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return `Join our Waitlist online or speak to the Destination ${getExcursionText(true)} team onboard.`;
        case "cfc":
            return `Inscrivez-vous sur notre liste d'attente en ligne ou adressez-vous à l'équipe ${getExcursionsText(true)} à bord.`;
        default:
            return "";
    }
}

export function getSpeakToOnboardTeamText(){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return `Please speak to your onboard Destination ${getExcursionText(true)} Team.`;
        case "cfc":
            return `Veuillez vous adresser à l'équipe ${getExcursionsText(true)} à bord`;
        default:
            return "";
    }
}

// we should use t() function in the component directly.
export function getBackToCruisePlannerLink(){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "/itinerary";
        case "cfc":
            return "/itineraire";
        default:
            return "/itinerary";
    }
}

export function formatTimeByTheme(time){
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return time;
        case "cfc":
            const [hours, minutes] = time.split(":");
            const h = String(parseInt(hours));
            if (minutes === "00") {
                return `${h}h`;
            }
            return `${h}h${minutes}`;
        default:
            return time;
    }
}